



























import OtDocumentList from '@/components/documents/document-list/ot-document-list.vue';
import OtDocumentsFilter from '@/components/documents/document-list/ot-documents-filter.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DocumentListLevel, DocumentListMode, DocumentsFilter } from '@/components/documents/document-models';
import { ProjectDetails } from '../project-models';

@Component({
  components: {
    OtDocumentList,
    OtDocumentsFilter,
  },
})
export default class OtProjectDocumentsIndex extends Vue {
  // * PROPS
  @Prop() private project!: ProjectDetails;

  // * REFS

  // * COMPUTED
  private get organisationGid() {
    return this.project.organisationGid;
  }
  private get projectGid() {
    return this.project.gid;
  }
  private get locationDescription() {
    return 'Project';
  }

  // * DATA
  private filters: DocumentsFilter | null = null;
  private level = DocumentListLevel.Project;
  private mode = DocumentListMode.Display;

  // * METHODS
  private handleFilterUpdate(nextFilter: DocumentsFilter) {
    this.filters = nextFilter;
  }

  // * LIFECYCLE
}
